// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyA5Dp3aSee97ha4Qb7lmridxpzFWM-VUDw",
    authDomain: "aborigen-99669.firebaseapp.com",
    projectId: "aborigen-99669",
    storageBucket: "aborigen-99669.appspot.com",
    messagingSenderId: "906535058175",
    appId: "1:906535058175:web:09234967fa3098832aeaca",
    measurementId: "G-93B8BNKYB7"
  },
  apikeyGoogle:'AIzaSyANV7alCyUNct5ZlSMl164gUYbF_2WwzGk',
  apiKeyStripe : 'pk_live_51TWiZbJuoe8DhOtSmK3yeaCdB5nkN7hsOqu7NXwn025qhu7cKygxhyjl0WzXgkGIFxSmw2fdg2P8ahT8bUh9djTE00AMm2WLDJ',
 serverURL: 'https://us-central1-aborigen-99669.cloudfunctions.net/api'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
